<template>
    <ul id="subscription-purchase-history">
        <li v-for="history in histories" class="screen-transition">
            <div class="item-info">
                <div class="purchase-date">{{ toDate(history.ltime) }} {{ characters.purchase }} ({{ characters[history.pay_kind] }})</div>
                <div class="item-title" v-if="history.period==30">{{ convTypeToString(history.type) }} {{ history.month }}{{ characters.for_month }}</div>
                <div class="item-title" v-if="history.period==365">{{ convTypeToString(history.type) }} 1{{ characters.for_year }}</div>
            </div>
            <div class="item-price-container">
                <span class="item-price" v-if="history.price !==0">{{ '¥' + history.price.toLocaleString() }}</span>
                <span class="item-price" v-if="history.price ===0">{{ characters.free }}</span>
            </div>
        </li>
        <div class="confirm">
            <button type="submit" @click="jumpSubscriptionStatus()">{{ characters.open_subscription_confirm_page }}</button>
        </div>
    </ul>
</template>

<script>
    export default {
        name: "subscription-purchase-history",
        props: ['json_characters'],
        data: function () {
            return {
                histories: Array,
                characters: Object,
            }
        },
        mounted() {
            axios.default
                .get('/subscription/purchase/history/get')
                .then(response => {
                    this.histories = response.data;
                });
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            convTypeToString(type) {
                if(type == 0) return this.characters.general_member;
                if(type == 1) return this.characters.subscription_member;
                // if(type == 2) return 'プレミアム会員';
            },
            jumpSubscriptionPurchase: function() {
                location.href="/subscription/purchase";
            },
            jumpSubscriptionStatus: function() {
                location.href="/subscription/confirm";
            },
            toDate: function (datetime) {
                let year = datetime.slice(0, 4);
                let month = datetime.slice(5, 7);
                let day = datetime.slice(8, 10);
                return year + "." + month + "." +day;
            }
        }
    }
</script>

<style scoped>
</style>
